import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function EvidenciaImagem({ api, id, documento }) {
  const [abrir, setAbrir] = useState(true);
  const [url, setUrl] = useState(null);
  const [erro, setErro] = useState(false);
  useEffect(() => {
    if (!abrir) return;
    let ativo = true, objeto;
    setUrl(null); setErro(false);
    axios.get(`${api}/${id}/documentos/${documento.id}`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }, responseType: 'blob',
    }).then(r => {
      if (!ativo) return;
      objeto = URL.createObjectURL(r.data); setUrl(objeto);
    }).catch(() => { if (ativo) setErro(true); });
    return () => { ativo = false; if (objeto) URL.revokeObjectURL(objeto); };
  }, [api, id, documento.id, abrir]);
  return !abrir ? <button type="button" onClick={() => setAbrir(true)}>Ver imagem</button> : erro ? <p role="alert">Não foi possível abrir a imagem. Recarregue a investigação.</p> : url
    ? <a href={url} target="_blank" rel="noopener noreferrer" aria-label={`Ampliar ${documento.versao}`}><img src={url} alt={documento.versao} style={{ maxWidth: '100%', maxHeight: 240, objectFit: 'contain' }} /></a>
    : <p role="status">Carregando imagem…</p>;
}

